import React, { useEffect, useState } from "react";
import Chart from "react-apexcharts";
import jsonData from "../../../../current-survey-numeric.json"; // Ensure the path is correct

const BarChartViz04 = ({ filterCriteria }) => {
  const [seriesData, setSeriesData] = useState([]);

  useEffect(() => {
    const countResponses = (data, criteria) => {
      const counts = { NR: 0, 1: 0, 2: 0, 3: 0, 4: 0, 5: 0 };

      // Debugging: Output the filter criteria
      console.log("Filter Criteria:", criteria);

      // Filter the data based on criteria
      const filteredData = data.filter((item) => {
        return Object.keys(criteria).every((key) => {
          if (!criteria[key] || criteria[key].length === 0) {
            // If the filter is not set or is empty, skip this criterion
            return true;
          }

          // Handle multi-select filters where the criteria is an array
          if (Array.isArray(criteria[key])) {
            return criteria[key].includes(item[key]);
          }

          // Debugging: Output comparison
          console.log(
            `Comparing: item[${key}] = ${item[key]} with criteria[${key}] = ${criteria[key]}`
          );

          // Check for matching criteria
          return item[key] === criteria[key];
        });
      });

      // Debugging: Output the filtered data
      console.log("Filtered Data:", filteredData);

      // Count responses
      filteredData.forEach((item) => {
        const response = item.SS_NMS2024_0016;
        if (response >= 1 && response <= 5) {
          counts[response]++;
        } else {
          counts.NR++;
        }
      });

      return Object.values(counts);
    };

    const newSeriesData = countResponses(jsonData, filterCriteria);
    setSeriesData(newSeriesData);

    // Debugging: Output the final series data
    console.log("Series Data:", newSeriesData);
  }, [filterCriteria]);

  const chartOptions = {
    series: [
      {
        name: "Count of Respondents",
        data: seriesData,
      },
    ],
    colors: ["#f28e2b", "#f28e2b", "#f1ce63", "#499894", "#499894", "#bab0ac"],
    chart: {
      type: "bar",
      height: "100%", // Ensure the chart fills the height of the container
    },
    legend: {
      show: false,
    },
    plotOptions: {
      bar: {
        borderRadius: 4,
        horizontal: false,
        distributed: true,
        dataLabels: {
          position: "top",
        },
      },
    },
    dataLabels: {
      enabled: true,
      offsetY: -20,
      style: {
        fontSize: "12px",
        colors: ["#263238"],
      },
    },
    xaxis: {
      categories: ["1", "2", "3", "4", "5", "NR"],
    },
    yaxis: {
      title: {
        text: "Count",
      },
    },
  };

  return (
    <div className="D13_Survey_Specific_Questions-chart-container">
      <Chart
        options={chartOptions}
        series={chartOptions.series}
        type={chartOptions.chart.type}
        height="80%"
        width="95%" // Ensure the chart fills the width of the container
      />
    </div>
  );
};

export default BarChartViz04;
